import React from "react";
import { Statistics } from "./Statistics";
import { defineMessages, FormattedMessage } from "react-intl";
import { tw } from "@noones/ui/tw";
import { useDailyStatistic } from "@pages/status-page/hooks/useDailyStatistic";
import { Skeleton } from "@noones/ui";
import { ContactSupport } from "./ContactSupport";
import { TransparancyDashboard } from "./TransparancyDashboard";

export const Volume = () => {
    const { data: dailyStatistic, isLoading } = useDailyStatistic();

    if (isLoading) {
        return <Skeleton height={670} className={tw.w_full.lg(tw.max_w_["368px"])} />;
    }

    return (
        <div className={tw.w_full.lg(tw.max_w_["368px"])}>
            <h1 className={tw.text_h1.font_semibold.my_0.mb_5}>
                <FormattedMessage {...messages.title} />
            </h1>

            <div className={tw.space_y_2}>
                <Statistics
                    data={dailyStatistic?.trades_daily_started}
                    description={<FormattedMessage {...messages.tradesDaily} />}
                />
                <Statistics
                    data={dailyStatistic?.transactions_daily}
                    description={<FormattedMessage {...messages.transactionsDaily} />}
                />
            </div>

            <TransparancyDashboard />
            <ContactSupport />
        </div>
    );
};

const messages = defineMessages({
    title: {
        id: "Volume.Header.title",
        defaultMessage: "Volume",
        description: "Volume",
    },
    tradesDaily: {
        id: "Volume.Header.tradesDaily",
        defaultMessage: "Daily number of trades",
        description: "title",
    },
    transactionsDaily: {
        id: "Header.transactionsDaily",
        defaultMessage: "Daily wallet transactions",
        description: "title",
    },
});
